import { toast } from "sonner";
import { Copy, Share2, Mail, MessageCircle } from "lucide-react";

export const ShareButtons = ({ link }) => {
  const msg = `I'm joining CricAnalyze! 🏏 Analyze. Improve. Play Better. Join the waitlist and discover the future of cricket video analysis: ${link}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Referral link copied"); }
    catch {
      const ta = document.createElement("textarea"); ta.value = link; document.body.appendChild(ta); ta.select();
      document.execCommand("copy"); ta.remove(); toast.success("Referral link copied");
    }
  };
  const native = async () => {
    if (navigator.share) { try { await navigator.share({ title: "CricAnalyze", text: msg, url: link }); } catch {} }
    else copy();
  };
  const btn = "flex items-center justify-center gap-2 px-4 py-3 rounded-full text-sm font-semibold transition-colors";
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="share-buttons">
      <button onClick={copy} data-testid="copy-referral-link-btn" className={`${btn} bg-[#B7FF3C] text-[#080A08] hover:bg-[#c9ff6a]`}><Copy size={16} />Copy Link</button>
      <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" data-testid="share-whatsapp-btn" className={`${btn} border border-[#2A362A] hover:border-[#25D366] text-white`}><MessageCircle size={16} className="text-[#25D366]" />WhatsApp</a>
      <button onClick={native} data-testid="share-native-btn" className={`${btn} border border-[#2A362A] hover:border-[#B7FF3C]/60 text-white`}><Share2 size={16} />Share</button>
      <a href={`mailto:?subject=${encodeURIComponent("Join me on CricAnalyze")}&body=${encodeURIComponent(msg)}`} data-testid="share-email-btn" className={`${btn} border border-[#2A362A] hover:border-[#B7FF3C]/60 text-white`}><Mail size={16} />Email</a>
    </div>
  );
};
